import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../../../App.css';
import 'rsuite/DatePicker/styles/index.css';
import Input from '../../Input';
import Button from '@mui/material/Button';
import BackIcon from '@mui/icons-material/Reply';
import { showNotification } from '../../../utils/NotificationUtils';
import { request } from '../../../utils/ApiUtils';

function ConfigDespesasForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [configDespesa, setConfigDespesa] = useState({ ativo: true, categoria: true })
    const [error, setError] = useState({})
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        load();
    }, [id]);

    const load = async () => {
        if (id) {
            request(`configdespesas/${id}`, {
                type: 'GET',
                callback: (data) => setConfigDespesa(data),
                callbackError: (responseData, message) => showNotification(message || 'Ocorreu um erro inesperado, tente novamente ou contate o suporte.', 'error')
            })

        } else {
            setConfigDespesa({ ativo: true });
        }
    }

    const salvar = async () => {
        setIsSaving(true);
        setConfigDespesa({ ...configDespesa });

        const method = configDespesa.id ? "PUT" : "POST";
        const url = configDespesa.id ? `configdespesas/${configDespesa.id}` : "configdespesas";

        request(url, {
            type: method,
            body: JSON.stringify(configDespesa),
            callback: (data) => {
                showNotification('Configuração salva', 'success');
                setConfigDespesa(Object.assign({}, data));
                if (!id) navigate(`/configdespesas/cadastro/${data.id}`);
            },
            callbackError: (responseData, message) => {
                if (responseData?.errors) {
                    setError(responseData.errors);
                }

                if (responseData?.handledError) {
                    if (responseData?.errors && Object.keys(responseData.errors).length > 0) {
                        Object.entries(responseData.errors).forEach(([key, value]) => {

                            showNotification(value, 'error', 5000);
                        });
                    } else

                        if (responseData?.error) {
                            showNotification(responseData.error, 'error', 5000);
                        }
                } else {
                    showNotification('Não foi possível salvar a configuração, revise os dados informados.', 'error');
                }
            },
            finally: () => {
                setIsSaving(false);
            }
        })
    };

    const handleInputChange = async (campo, configDespesaUpdate) => {
        error[campo] = undefined;
        setError(error)

        setConfigDespesa({ ...configDespesa, ...configDespesaUpdate });
    };


    return (
        <div className="form-container">

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                top: "0", // Aqui muda pra aparecer no topo
                right: "30px",
                maxHeight: "100vh",
                zIndex: 9999
            }}></div>

            <div className="header-container-form">
                <h1 style={{ color: '#5E5E5E' }}>Configuração de despesas</h1>
                <Button variant="text" onClick={() => navigate(`/configdespesas`)} startIcon={(<BackIcon style={{ fontSize: '2rem', fontWeight: 'bold', color: '#0057a3' }} />)} />
            </div>


            <div className='row'>
                <Input id="nome"
                    value={configDespesa?.nome}
                    parameters={{ error: error.nome, width: '40%', label: "Nome da classificação*", onChange: (value) => handleInputChange('nome', { nome: value }) }} />

                <div className="checkbox-group">
                    <input type="checkbox" id="categoria" name="categoria" checked={configDespesa.categoria} onClick={() => handleInputChange('categoria', { categoria: !configDespesa?.categoria, centroCusto: !!configDespesa?.categoria })} />
                    <label htmlFor="categoria" className="checkbox-label">Categoria</label>
                </div>

                <div className="checkbox-group">
                    <input type="checkbox" id="centroCusto" name="centroCusto" checked={configDespesa.centroCusto} onClick={() => handleInputChange('centroCusto', { centroCusto: !configDespesa?.centroCusto, categoria: !!configDespesa?.centroCusto })} />
                    <label htmlFor="centroCusto" className="checkbox-label">Centro de custo</label>
                </div>

                <div className="checkbox-group">
                    <input type="checkbox" id="ativo" name="ativo" checked={configDespesa.ativo} onClick={() => handleInputChange('ativo', { ativo: !configDespesa.ativo })} />
                    <label htmlFor="ativo" className="checkbox-label">Ativo</label>
                </div>

            </div>

            {(
                <button onClick={() => salvar()} className="add-button">
                    Salvar
                </button>
            )}
        </div>
    );
}

export default ConfigDespesasForm;
